import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {NgForOf, NgIf} from "@angular/common";
import {Subscription} from "rxjs";
import {TranslateModule} from "@ngx-translate/core";
import {dateUtils} from "../../../../helpers/date.utils";
import {PlanningRegionApiService} from "../../../../services/api/planning-region-api.service";
import {ToastService} from "../../../../services/toaster.service";
import {BaseComponent} from "../../../base/base.component";
import {Cinema} from "../../../../models/cinema.model";

@Component({
  selector: 'app-planning-region-prog-annonce-modal',
  templateUrl: './planning-region-prog-annonce-modal.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    TranslateModule,
    FormsModule,
    NgbInputDatepicker
  ],
  styleUrls: ['./planning-region-prog-annonce-modal.component.scss']
})
export class PlanningRegionProgAnnonceModalComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() cinemas: Cinema[] = [];
  @Input() title: string = '';

  private subscriptions: Subscription = new Subscription();

  public dateProgControl: FormControl = new FormControl(dateUtils.getToday());
  public cinemaControl: FormControl = new FormControl(null);

  constructor(
    public activeModal: NgbActiveModal,
    private planningRegionApiService: PlanningRegionApiService,
    private toastService: ToastService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.cinemas.length) {
      this.cinemaControl.setValue(this.cinemas[0].id_cinema);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.activeModal.close();
  }

  updateProgAnnonce(): void {
    const selectedCinemaId = this.cinemaControl.value;
    const selectedDate = dateUtils.formatDateStruct(dateUtils.toDate(this.dateProgControl.value));
    const subscription = this.planningRegionApiService.updateProgAnnonce(this.cookies, selectedCinemaId, selectedDate)
      .subscribe(
        () => {
          this.toastService.showSuccess('toast.success');
          this.planningRegionApiService.reloadPlanningRegion(this.idRegion);
          this.closeModal();
        },
        () => this.toastService.showDanger('toast.error')
      );
    this.subscriptions.add(subscription);
  }
}
